import React from "react";
import { TableCell, Typography } from "@material-ui/core";
import {
  disbursementReasonDictionary,
  DisbursementStatus,
  disbursementStatusDictionary,
  DPProviderDisbursement,
} from "Shared/types/Disbursements";
import pretty from "Shared/pretty";
import { DPLineThroughTableRow } from "Components/DP";

export const ProviderDisbursementsTableRow = ({
  createdAt,
  providerAccount: {
    externalId,
    employee
  },
  disbursementReceivedOn,
  reason,
  totalAmountCents,
  userBankAccount,
  status,
  partnerInvoiceId,
  requester
}: DPProviderDisbursement) => {
  const isRejected = status === DisbursementStatus.rejected;

  return (
    <DPLineThroughTableRow lineThrough={isRejected}>
      <TableCell>
        <Typography>
          {pretty.date(createdAt)}
        </Typography>
        <Typography noWrap>
          {pretty.date(createdAt, { format: "h:mm:ss a" })}
        </Typography>
      </TableCell>
      <TableCell>
        {pretty.fullName(employee?.firstName || "", employee?.lastName || "")}
      </TableCell>
      <TableCell>
        {externalId}
      </TableCell>
      <TableCell>
        {disbursementReceivedOn && pretty.date(disbursementReceivedOn)}
      </TableCell>
      <TableCell>
        {userBankAccount.name} {pretty.account(userBankAccount.accountNumber)}
      </TableCell>
      <TableCell>{pretty.dollar(totalAmountCents)}</TableCell>
      <TableCell>
        {disbursementReasonDictionary[reason]}
      </TableCell>
      <TableCell>
        {pretty.fullName(requester?.firstName || "", requester?.lastName || "")}
      </TableCell>
      <TableCell>
        {partnerInvoiceId}
      </TableCell>
      <TableCell>
        {disbursementStatusDictionary[status as DisbursementStatus]}
      </TableCell>
    </DPLineThroughTableRow>
  );
};
